import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./bootstrap.min.css";
import CustomerComplaintForm from "./pages/CustomerComplaintForm";
import Complaints from "./pages/ComplaintConfirmation";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CustomerComplaintForm />} />
        <Route path="/confirm" element={<Complaints />} />
      </Routes>
    </Router>
  );
};

export default App;